import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { TranslatePipeModule } from "../../../language/language.module";
import { LoginComponent } from "./login.component";
import { LoginRoutingModule } from "./login-routing.module";
import { LoginService } from "./login.service";
import { SessionStorageService } from "ng2-webstorage";
import { AuthService } from "../auth/auth.service";

@NgModule({
  imports: [CommonModule, FormsModule, LoginRoutingModule, TranslatePipeModule],
  declarations: [LoginComponent],
  providers: [LoginService, SessionStorageService, AuthService]
})
export class LoginModule {}
